module.exports = __webpack_public_path__ + "static/img/grapefruit-m.ba8e4f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/grapefruit-m.jpg
// module id = hNyz
// module chunks = 0